export function create_UUID(){
  let dt = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

export function extractIdFromSSR(params: any) {
  // Handle cases where params.slug could be an array
  const slug = Array.isArray(params.slug) ? params.slug.join('-') : params.slug;

  // Decode the slug to handle URL-encoded characters like %3f
  const decodedSlug = decodeURIComponent(slug);

  // Extract the path without query parameters
  const fullPath = decodedSlug.split('?')[0].split('#')[0];

  // Split the path to extract the ID
  const pathSegments = fullPath.split('-');
  let idString = pathSegments[pathSegments.length - 1];

  // Remove any file extensions like .html
  idString = idString.replace(/\.html$/, '');

  // when path is just an id instead of slug with id
  if (idString.includes("/")) {
    const splitIdString = idString.split("/")
    idString = splitIdString[splitIdString.length - 1]
  }

  // Convert idString to a number and validate it's a positive integer
  const id = Number(idString);
  return Number.isInteger(id) && id > 0 ? id : null;
}

export function extractIdFromUrl(router: any) {
  if (!router?.asPath) return null;

  // Decode the asPath to handle URL-encoded characters
  const decodedPath = decodeURIComponent(router.asPath);

  // Extract the path without query parameters
  const fullPath = decodedPath.split('?')[0].split('#')[0];

  // Split the path to extract the ID
  const pathSegments = fullPath.split('-');
  let idString = pathSegments[pathSegments.length - 1];

  // when path is just an id instead of slug with id
  if (idString.includes("/")) {
    const splitIdString = idString.split("/")
    idString = splitIdString[splitIdString.length - 1]
  }

  // Remove file extensions like .html
  idString = idString.replace(/\.html$/, '');

  // Convert idString to a number and validate it's a positive integer
  const id = Number(idString);
  return Number.isInteger(id) && id > 0 ? id : null;
}
